import React from 'react';
import PropTypes from 'prop-types';

export const FormResetButton = ({ children, disabled = false, ...props }) => {
  return (
    <a href="#" className="swformreset__btn" disabled={disabled} {...props}>
      {children}
    </a>
  );
};

FormResetButton.propTypes = {
  children: PropTypes.any.isRequired,
  disabled: PropTypes.bool
};
